<script>
import Button from 'primevue/button';
import Card from 'primevue/card';
import SelectButton from 'primevue/selectbutton';
import Password from 'primevue/password';

import SecurityService from '../../services/security';
import { required, minLength, helpers } from "@vuelidate/validators";
import { useVuelidate } from "@vuelidate/core";

const upperCaseLetter = helpers.withMessage('No upper case letter in password', function(el){
    return new RegExp('[A-Z]+').test(el)
});

const lowerCaseLetter = helpers.withMessage('No lower case letter in password', function(el){
    return new RegExp('[a-z]+').test(el)
});

const specialCharacter = helpers.withMessage('No Special character in password', function(el){
    return new RegExp('[!@#$%^&*°()_+=\\[{\\]};:<>|./?,-]').test(el)
});

const numberPresence = helpers.withMessage('No Number in password', function(el){
    return new RegExp('[0-9]+').test(el)
});

const confirmEqual = helpers.withMessage('Confirm password doesn\'t match', function(el){
    return el === this.data.confirmNewPassword;
});

export default{
    setup: () => ({ v$: useVuelidate() }),
    props: ['code'],
    components: {Button,Card,SelectButton,Password},
    data(){
        return{
            submitted: false,
            formData: {
                temporaryCode: this.code,
                password: '',
            },
            data: {
                confirmNewPassword: ''
            },
            selectedLanguage: this.$store.state.security.language,
            languages: [ 
                {name: 'English', code: 'en'},
                {name: 'Italiano', code: 'it'}
            ],
        }
    },
     validations(){
           return {
                formData: {
                    password: {required, minLength: minLength(10), upperCaseLetter, lowerCaseLetter, specialCharacter, numberPresence, confirmEqual},
                },
                data: {
                    confirmNewPassword: {required},
                }
            }
        },
    mounted(){
    },
    computed: {},
    methods: {
        setLanguage(e){
            this.$store.dispatch("security/setLanguage", e.value);
            this.$root.$i18n.changeLocale(this.$store.state.security.language);
        },
        onSubmit(valid) {
            this.submitted = true;
            if(valid){
                this.$store.dispatch("generic/setLoading", true);
                SecurityService.completeSelfResetPassword(this.formData, response => {
                    this.$store.dispatch("generic/setLoading", false);
                    this.submitted = false;
                    if(response.success){
                        this.$toast.add({severity:'success', summary: 'Success Message', detail: this.$t('messages.passwordResetSuccessMessage'), life: 3000});     
                        this.$router.push('/login');
                    }else{
                        this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                    }
                });
            }
        },
    }
};
</script>

<template>
<main>

    <Card style="width: 20rem; margin: 0 auto;">
        <template #title>
            {{$t('resetPassword')}}
        </template>
        <template #content>
            <form @submit.prevent="onSubmit(!v$.$invalid)">
                <div class="formgrid m-2">
                    <div class="my-3">
                        <span class="p-float-label" >
                            <Password id="password" v-model="formData.password" :feedback="false" toggleMask :class="{'p-invalid':v$.formData.password.$invalid && submitted, 'w-full': true}"></Password>
                            <label for="password">{{$t('changePassword.newPassword')}}</label>
                        </span>
                        <small v-if="(v$.formData.password.$invalid && submitted) || v$.formData.password.$pending.$response" class="p-error">
                            {{$t('changePassword.RulesNotMatched')}}
                        </small>
                    </div>
                    <div class="my-3">
                        <span class="p-float-label" >
                            <Password id="confirmNewPassword" v-model="data.confirmNewPassword" :feedback="false" toggleMask :class="{'p-invalid':v$.data.confirmNewPassword.$invalid && submitted, 'w-full': true}"></Password>
                            <label for="confirmNewPassword">{{$t('changePassword.confirmNewPassword')}}</label>
                        </span>
                        
                        <div v-if="(v$.data.confirmNewPassword.$invalid && submitted) || v$.data.confirmNewPassword.$pending.$response">
                            <small class="p-error" v-for="error in v$.data.confirmNewPassword.$silentErrors" :key="error.$validator">
                                {{error.$message}}
                            </small>
                        </div>
                    </div>
                    <div class="mt-4">
                        <h5 class="mb-2">{{$t('changePassword.newPasswordRules')}}</h5>
                        <ul class="mb-2">
                            <li><i :class="(!formData.password || v$.formData.password.minLength?.$invalid) ? 'text-red pi pi-stop' : 'text-green-400 pi pi-check-square'"></i>{{$t('changePassword.minLength')}}</li>
                            <li><i :class="(!formData.password || v$.formData.password.upperCaseLetter?.$invalid) ? 'text-red pi pi-stop' : 'text-green-400 pi pi-check-square'"></i>{{$t('changePassword.upperCaseLetter')}} </li>
                            <li><i :class="(!formData.password || v$.formData.password.lowerCaseLetter?.$invalid) ? 'text-red pi pi-stop' : 'text-green-400 pi pi-check-square'"></i>{{$t('changePassword.lowerCaseLetter')}}</li>
                            <li><i :class="(!formData.password || v$.formData.password.numberPresence?.$invalid) ? 'text-red pi pi-stop' : 'text-green-400 pi pi-check-square'"></i>{{$t('changePassword.numberPresence')}}</li>
                            <li><i :class="(!formData.password || v$.formData.password.specialCharacter?.$invalid) ? 'text-red pi pi-stop' : 'text-green-400 pi pi-check-square'"></i>{{$t('changePassword.specialCharacter')}}</li>
                            <li><i :class="(!formData.password || v$.formData.password.confirmEqual?.$invalid) ? 'text-red pi pi-stop' : 'text-green-400 pi pi-check-square'"></i>{{$t('changePassword.confirmEqual')}}</li>
                        </ul>
                    </div>
                    <div class="my-3" style="text-decoration: none;">
                        <router-link to="/login">{{$t('changePassword.returnLogin')}}</router-link>
                    </div>
                    <div class="" style="text-align: center;">                         
                        <SelectButton v-model="selectedLanguage" :options="languages" optionLabel="name" optionValue="code" @change="setLanguage" />  
                    </div>
                </div>
                <div class="col-11 mx-3">
                </div>
            </form>
        </template>
    
         <template #footer> 
            <Button icon="pi pi-check" class="w-full" :label="$t('btn.changePassword')" type="submit" @click="onSubmit(!v$.$invalid)" />
        </template>
    </Card>
</main>
</template>

<style scoped>

ul {
    list-style: none;
    padding: 0;
    margin: 0;
}

li {
    padding: 3px 0;
}

li > i{
    padding-right: 5px;
}
</style>